<template>
    <div class="row progress-container progress-base" :class="`progress-${type}`">

        <div class="col-3">

    <span class="progress-badge float-right">
      <slot name="label">
        {{ label }}
      </slot>
    </span>
        </div>
        <div class="progress col-8 p-0" style="height: 2px;">
            <div
                    class="progress-bar"
                    :class="computedClasses"
                    role="progressbar"
                    :aria-valuenow="value"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="`width: ${value}%;`"
            >
            </div>
        </div>
        <div class="col-1">
                <slot>
                    <span class="progress-value" v-if="showValue"> {{ value }}% </span>
                </slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'n-progress',
        props: {
            striped: Boolean,
            showValue: Boolean,
            animated: Boolean,
            label: String,
            height: {
                type: Number,
                default: 1
            },
            type: {
                type: String,
                default: 'default'
            },
            value: {
                type: Number,
                default: 0,
                validator: value => {
                    return value >= 0 && value <= 100;
                }
            }
        },
        computed: {
            computedClasses() {
                return [
                    {'progress-bar-striped': this.striped},
                    {'progress-bar-animated': this.animated}
                ];
            }
        }
    };
</script>
<style></style>
